<template>
  <div class="invest">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.showInvest') }}
        </h3>
      </div>
      <div class="box-body">
        <invest-form :editable="false" />
      </div>
    </div>
  </div>
</template>

<script>
import InvestForm from './Form'

export default {
  name: 'Show',
  components: { InvestForm },
  metaInfo () {
    return {
      title: this.$t('string.showInvest'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
